import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../lib/query-client';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export interface UseQueryProviderProps {
  readonly children?: React.ReactNode;
}

/**
 * UseQueryProvider sets up the React Query (TanStack Query) environment.
 * It provides the queryClient to the entire application and includes devtools for development.
 */
export function UseQueryProvider({ children }: UseQueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
